import { ChangeDetectionStrategy, Component, inject, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { AuthService } from '../services/auth.service';

import { Router } from '@angular/router';
import { ConfirmationService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { Parameters } from '../utilities/parameters';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [
    ButtonModule,
    ConfirmDialogModule
],
  templateUrl: './home.component.html',
  styles: ``,
  changeDetection: ChangeDetectionStrategy.Eager,
  providers: [ConfirmationService]
})
export class HomeComponent implements OnDestroy {
  private translate = inject(TranslateService);

  userDataAvailableSubscription: Subscription;

  constructor(private authService: AuthService, private router: Router, private confirmationService: ConfirmationService) {

    // TODO: Da verificare se deve essere qui
    this.userDataAvailableSubscription = this.authService.userDataAvailable.subscribe(r => {
      if (r) {
        if (!Parameters.confirmedConsents()) {
          const keysToTranslate = ['messages.privacy', 'consents.privacy'];

          this.translate.get(keysToTranslate).subscribe((translations) => {
            this.confirmationService.confirm({
              message: translations['messages.privacy'],
              header: translations['consents.privacy'],
              closable: false,
              closeOnEscape: false,
              icon: 'pi pi-info-circle',
              rejectVisible: false,
              acceptButtonProps: {
                label: 'Ok',
              },
              accept: () => {
                this.router.navigate(['/currentuser']);
              },
              reject: () => {
              },
            });
          });
        }
      }
    })
  }

  ngOnDestroy() {
    if (this.userDataAvailableSubscription) {
      this.userDataAvailableSubscription.unsubscribe();
    }
  }
}
